import Logs from './Logs'
import Servers from './Servers'
import Main from './Main'
import Backup from './Backup'
import Fileexchange from './Fileexchange'
import Exchange from './Exchange'


export default { Main, Logs, Servers, Backup, Fileexchange, Exchange }